$(function(){

    var canvasWidth;
    var canvasHeight;
    var spFlag = false;
    var loadImageFlag = false;
    var viewGnav = false;

    function onResize() {
        canvasWidth = window.innerWidth ? window.innerWidth: $(window).width();
        canvasHeight = window.innerHeight ? window.innerHeight: $(window).height();
        if (canvasWidth <= 768) {
            if(!spFlag) {
                //console.log("spImage -> SP");
                $('.-spImage').setSpImages(spFlag);
                $('.-retina').removeRetinaImagesStyle();
            }
            spFlag = true;
        } else {
            if(spFlag) {
                $('.-spImage').setSpImages(spFlag);
                loadImageFlag = $('.-retina').retinaImages();
                //console.log("spImage -> PC");
            }

            if (!loadImageFlag) {
                loadImageFlag = $('.-retina').retinaImages();
            }

            spFlag = false;
        }
    }

    $(window).scroll(function(){
        if(viewGnav === false) {
            if($(window).scrollTop() >= 800) {
                viewGnav = true;
                $('header').not(":animated").css({top:'-100px', position:'fixed'}).animate({'top':'0'}, 800);
            }
        }
        else {
            if($(window).scrollTop() <= 700) {
                viewGnav = false;
                $('header').not(":animated").animate({'top':'-100px'}, 300, function() {
                    $(this).css({top:'0', position:'absolute'});
                });

            }
        }
    });


    /////////////////////////////////////////////////////////////////////////////////////////


    function setup() {
        $('a[href^="#"]').SmoothScroll();
    }
    $("a.spMenu__open").on('click', function(e) {
        e.preventDefault();
        $(".spMenu__area--sp").show();

    });
    $('a.spMenu__close').on('click', function(e) {
        e.preventDefault();
        $('.spMenu__area--sp').hide();
    });




    /////////////////////////////////////////////////////////////////////////////////////////

    $(window).resize(function() {
        onResize();
    });

    $(window).ready(function() {
        setup();
        onResize();
    });

    $(window).load(function() {
    });

});

$(document).ready(function() {
  var path = window.location.pathname;

  if (path.startsWith("/en")) {
    $(".lang").addClass("checked");
    $(".lang input[type='checkbox']").prop("checked", true);
  }
});


$(".lang").on("click", function() {
  $(this).toggleClass("checked");
  var checkbox = $(this).find('input[type="checkbox"]');
  checkbox.prop("checked", !checkbox.prop("checked"));

  updateURL(checkbox.prop("checked"));
});

function updateURL(isChecked) {
  var currentUrl = window.location.href;
  var baseUrl = "https://fc13ee.myshopify.com";
  var path = window.location.pathname;

  if (isChecked) {
    // 英語のURLにリダイレクト
    if (!path.startsWith("/en")) {
      path = "/en" + path;
    }
    window.location.href = baseUrl + path;
  } else {
    // 元のURLにリダイレクト
    var newPath = path.replace("/en", "/");
    window.location.href = baseUrl + newPath;
  }
}

  function loadCSS(href) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  window.addEventListener('DOMContentLoaded', function() {
    loadCSS("{{ 'bootstrap.min.css' | asset_url }}");
    loadCSS("{{ 'shop.css' | asset_url }}");
    loadCSS("{{ 'customize.css' | asset_url }}");
    loadCSS("{{ 'page-original.css' | asset_url }}");
  });
